



















































































































































































































































import Vue from "vue";
import Header from "../components/Header.vue";

interface ResultadoIMC {
  imc: string;
  categoria: string;
  color: string;
  mensaje: string;
}

export default Vue.extend({
  name: "imc",
  components: { Header },
  data() {
    return {
      Altura: null as number | null,
      Peso: null as number | null,
      resultado: null as ResultadoIMC | null,
      error: "" as string,
      mostrarRecursos: false,
    };
  },
  created() {
    const p = this.$store.state.profile;
    if (p.altura) this.Altura = p.altura;
    if (p.peso) this.Peso = p.peso;
  },
  methods: {
    calcular() {
      this.error = "";
      this.resultado = null;

      if (!this.Altura || !this.Peso) {
        this.error = this.$t("imc.error_campos") as string;
        return;
      }
      if (this.Altura < 100 || this.Altura > 250) {
        this.error = this.$t("imc.error_altura") as string;
        return;
      }
      if (this.Peso < 1 || this.Peso > 300) {
        this.error = this.$t("imc.error_peso") as string;
        return;
      }

      const alturaM = this.Altura / 100;
      const imc = this.Peso / (alturaM * alturaM);
      const imcStr = imc.toFixed(1);

      let categoria: string;
      let color: string;
      let mensaje: string;

      if (imc < 18.5) {
        categoria = this.$t("imc.bajo_peso") as string;
        color = "#F59E0B";
        mensaje = this.$t("imc.msg_bajo_peso") as string;
      } else if (imc < 25) {
        categoria = this.$t("imc.normal") as string;
        color = "#10B981";
        mensaje = this.$t("imc.msg_normal") as string;
      } else if (imc < 30) {
        categoria = this.$t("imc.sobrepeso") as string;
        color = "#F59E0B";
        mensaje = this.$t("imc.msg_sobrepeso") as string;
      } else {
        categoria = this.$t("imc.obesidad") as string;
        color = "#F87171";
        mensaje = this.$t("imc.msg_obesidad") as string;
      }

      this.resultado = { imc: imcStr, categoria, color, mensaje };
      this.$store.commit("setProfile", {
        altura: this.Altura,
        peso: this.Peso,
      });
    },
  },
});
